<template>
  <div
    id="buttons"
    class="d-flex "
    :class="{ newButtonsStyle: $root.sectionIndexHome != 1 }"
  >
     <!-- <button
      data-aos="zoom-in-up"
      data-aos-duration="2500"
      data-aos-delay="2500"
      data-aos-once="false"
      v-if="$root.sectionIndexHome != 1 && $route.name!='healthAmbassador'"
      class="reStyleToggle"
      @click="toggleMenu()"
      id="toggleMenu"
    >
      <i class="fa fa-bars"></i>
    </button>  -->
    <a title="فايل راهنما" target="_blank" href="https://test.mmc.ir/uploadFileFile/80587452-4f41-4ec5-889c-d208565e3a86.pdf">
          <svg height="28px" width="28px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	         viewBox="0 0 431.855 431.855" xml:space="preserve">
            <g>
          	<path style="fill:green;" d="M215.936,0C96.722,0,0.008,96.592,0.008,215.814c0,119.336,96.714,216.041,215.927,216.041
		c119.279,0,215.911-96.706,215.911-216.041C431.847,96.592,335.214,0,215.936,0z M231.323,335.962
		c-5.015,4.463-10.827,6.706-17.411,6.706c-6.812,0-12.754-2.203-17.826-6.617c-5.08-4.406-7.625-10.575-7.625-18.501
		c0-7.031,2.463-12.949,7.373-17.745c4.91-4.796,10.933-7.194,18.078-7.194c7.031,0,12.949,2.398,17.753,7.194
		c4.796,4.796,7.202,10.713,7.202,17.745C238.858,325.362,236.346,331.5,231.323,335.962z M293.856,180.934
		c-3.853,7.145-8.429,13.306-13.737,18.501c-5.292,5.194-14.81,13.924-28.548,26.198c-3.788,3.463-6.836,6.503-9.12,9.12
		c-2.284,2.626-3.991,5.023-5.105,7.202c-1.122,2.178-1.983,4.357-2.593,6.535c-0.61,2.17-1.528,5.999-2.772,11.469
		c-2.113,11.608-8.754,17.411-19.915,17.411c-5.804,0-10.681-1.894-14.656-5.69c-3.959-3.796-5.934-9.429-5.934-16.907
		c0-9.372,1.455-17.493,4.357-24.361c2.886-6.869,6.747-12.892,11.543-18.086c4.804-5.194,11.274-11.356,19.427-18.501
		c7.145-6.251,12.307-10.965,15.485-14.144c3.186-3.186,5.861-6.73,8.031-10.632c2.187-3.91,3.26-8.145,3.26-12.721
		c0-8.933-3.308-16.46-9.957-22.597c-6.641-6.137-15.209-9.21-25.703-9.21c-12.282,0-21.321,3.097-27.125,9.291
		c-5.804,6.194-10.705,15.314-14.729,27.369c-3.804,12.616-11.006,18.923-21.598,18.923c-6.251,0-11.526-2.203-15.826-6.609
		c-4.292-4.406-6.438-9.177-6.438-14.314c0-10.6,3.406-21.346,10.21-32.23c6.812-10.884,16.745-19.899,29.807-27.036
		c13.054-7.145,28.296-10.722,45.699-10.722c16.184,0,30.466,2.991,42.854,8.966c12.388,5.966,21.963,14.087,28.718,24.361
		        c6.747,10.266,10.128,21.427,10.128,33.482C299.635,165.473,297.709,173.789,293.856,180.934z"/>
            </g>
          </svg>
   </a> 
    <router-link  v-if="!this.user"  to="/loginCalibrationLab"  target="_blank"  class="btn btn-success " > {{$cookie.get('ltrTheme')?"Login/Register":"ورود/ثبت نام "}}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-label="User account" role="img"> <path fill="white" d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-5.33 0-8 2.67-8 6v2h16v-2c0-3.33-2.67-6-8-6Z"/> </svg>
    </router-link> 
    <router-link v-else  to="/admin-panel/calibrationLab-homePage"  target="_blank"  class="btn btn-success " >
       {{ this.user.name +"   "+ this.user.lastName }}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-label="User account" role="img"> <path fill="white" d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-5.33 0-8 2.67-8 6v2h16v-2c0-3.33-2.67-6-8-6Z"/> </svg>
    </router-link> 
    <div  class="">
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="31"
        height="30"
        viewBox="0 0 31 30"
      >
        <image
          id="Layer_2748"
          data-name="Layer 2748"
          width="31"
          height="30"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAABHNCSVQICAgIfAhkiAAAAuVJREFUSEu9l0uITlEcwOfzjighomQniR0lC7FSXhslO6FsbWWNoshKKSxYyJDHJEOhRGhEMrHwyBSmvI3xfozfbzqnbvc73/fde2uc+vWdzj33/M75n8c9X21gYKAtkaZTthyWgPka/ISncAUuwZfMe+PIz4RpMDaU2/BHeAEv4U/eU8vJbWQbbIHJqV6Fsof87oZTMBfmgO/aSaViXpS+gzvwLNtmVj6LB8dgcRNp/tEBCu7CCPjb5D2fm+7BrdC5tiifRMFVmFdCbNWT0AFjEu/9pmxYwMdGYTR0wc3BghD2I+Q3lBRb/ThcSMiNwhTog/4gjR0YTuY89ChfROZG6FlZf0r+g0YWwmZwrk+A4XbUJqfgNZxWfojMxrLWUD8l/84zd8r6UMfw74cHuQ50KO+h0G1SJaXkrnTnehmsCUIdOyHuglHk7yt3K1i5Smo050o+w+pMBHaQfwKKDX2v8uQpU7AnjeS+/gumwq7QltvydoiEg+0bSrkr3i24HdzKduI5jAyR7h9KuQO2A4rthEdsnF5/Pym3ggdAldQs7LE9V7tT64hjcs5fKe8l4wehSioiT7XroutW3k5mbRUz71SVG4VO5avInPuPco9Xj9125YbAw35+hQ5UGbnHrF+2rvhhMeyGv2wqK3fUXkJ0fYtyV7ufxhUl7WXlRvkyPNKTv0wYDk+loqmM3HA/hosweKrmr1ErKTsDhqdIKip3dft5PWu4Y8N5ueWb4CAU+dgUkSt2nt1R77MjSsl97kXADrQ6+VrJneMPIdRv86FsJLfeOjgM8SqcmoZmcsVvgtgrdF1qJrfyUjgKM1IvU9ZIrtgLhCv7a4N36xZcqt7s0IEFiYd5uevExdoN16Huj0K2jVYjj3XHk9kHLsZsysr9UnmB8FqsvGUqKo8NKd8DE0OB8k6YAH4dr4E300KprNxG/Wu0F7yhun38y+Th4d8hR144VZHbuFtwK3hL8Vrsqi6d/gFmAP87hbs6GgAAAABJRU5ErkJggg=="
        />
      </svg> -->
      <!-- <span>{{
        $cookie.get("ltrTheme") ? "Calibration Lab" : "آزمايشگاه كاليبراسيون"
      }}</span> -->
   </div>
    
  </div>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
//import search from "@/components/front/shared/searchModal.vue";
import RoundedButton from "@/components/front/shared/roundedButton.vue";
import menuBar from "@/components/front/home/slider/header/menu.vue";
import menuSection from "@/components/front/shared/menuSection.vue";
//import logo from "@/components/front/shared/logo.vue";
import { BModal } from "bootstrap-vue";
export default {
  components: {
    //logo,
    menuBar,
   // search,
    menuSection,
    BModal,
    RoundedButton,
  },
  methods: {
    getProfile(needCategories = false) {    
  
        this.$axios
          .get("CalibrationLabUsers/profile")
          .then((res) => {
            this.isSuccess = true;
           // debugger;
            this.user = res.data.data;
           // this.isLoading = true;
         //   if (needCategories) this.getAllCategories();
          })
          .catch((err) => {
           // debugger;           
            this.isSuccess = false;
            this.user = null;
            //if( res.data.data != null)
            //{
              //debugger;
              if(err.response.data.message != "پارامتر های ارسالی معتبر نیستند")
              {
                this.$toast.error(err.response.data.message);
              }
           // }
          });
        
      },
    showSection(section, flag) {
      if (flag == true) {
        this[section] = true;
      }
      setTimeout(() => {
        document.getElementById(section).focus();
      }, 500);
    },
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    resetModal() {
      this.showModal = false;
      this.fullName = "";
      this.mobile = "";
      this.email = "";
      this.text = "";
    },
    toggleMenu() {
      this.showMenuModal = !this.showMenuModal;
    },
    exitSearch(flag) {
      this.showSearch = flag;
    },
  },
  validations: {
    fullName: {
      required,
      minLength: minLength(5),
    },
    email: {
      required,
      email,
    },
    text: {
      required,
      minLength: minLength(20),
    },
    mobile: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(5),
    },
  },
  data() {
    return {
      showSearch: false,
      showMenuModal: false,
      disabled: false,
      showModal: false,
      fullName: "",
      mobile: "",
      email: "",
      text: "",
      writeEamil: false,
      writeMobile: false,
      writeFullName: false,
      user: null,
     // isLoading: false,    // برای نشان دادن لودینگ در حین درخواست
    };
  },
  computed: {
    menu() {
      return this.$store.getters.getMenus;
    },
    utilityLink() {
      return this.$store.getters.getUtilityLinks;
    },
    brands() {
      this.$store.getters.getBrands;
    },
  },
  // mounted() {
  //     this.getProfile(true);
  //   },
    created() {  
    // یا mounted بسته به زمان لازم  
       this.getProfile(true);
    }, 
};
</script>
<!-- <style>
#mobileMenu nav ul {
  flex-direction: column !important;
}
.newButtonsStyle {
  justify-content: flex-start !important;
  gap: 10px;
}
.orangeSvg path {
  fill: #f5992c;
}
#utilityModal___BV_modal_content_ {
  width: max-content !important;
  margin: auto;
}
div#utilityBox ul li a {
  font-size: 22px;
  transition: all 1s;
}
div#utilityBox ul li a:hover {
  color: var(--color-theme);
}
div#utilityBox ul li {
  text-align: right;
  color: var(--color-theme);
}
div#utilityBox ul {
  direction: rtl;
  list-style: disc;
  color: var(--theme-color);
}
div#utilityBox {
  width: 350px;
  margin-right: 10px;
}
</style> -->
